<z-select
    id="{{ id() }}"
    [options]="options()"
    [optionLabel]="optionLabel()"
    [optionValue]="optionValue()"
    [placeholder]="placeholder()"
    [label]="label()"
    [class]="class"
    [showClear]="false"
    [readonly]="
        rootFormGroup?.form?.controls?.['CompletionDateTime']?.value !=
        undefined
    "
    [(ngModel)]="model"
    (ngModelChange)="onModelChange($event)"
    [ngModelOptions]="{ standalone: true }"
/>
